import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import ApiClientsCreateModal from './ApiClientsCreateModal';
import ApiClientsList from './ApiClientsList';

import { PlusCircleIcon } from 'CommonComponents/icons';

const CREATE_CLIENT_MODAL_ID = 'create-api-client-modal';

export default function ApiClientsIndex(props) {
    const [request, setRequest] = useState(false);
    const [apps, setApps] = useState([]);
    const [isLoading, setIsLoading] = useState({});

    useEffect(() => {
        fetchClients();
    }, []);

    const fetchClients = () => {
        setRequest(true);
        axios
            .get(props.fetchUrl)
            .then((res) => {
                setApps(res.data.clients);
                closeModal();
            })
            .catch((e) => {
                console.log(e.response);
            })
            .finally(() => {
                setRequest(false);
            });
    };

    const storeNewApp = (data) => {
        setRequest(true);
        axios
            .post(props.storeUrl, data)
            .then((res) => {
                fetchClients();
            })
            .catch((e) => {
                console.log(e.response);
                setRequest(false);
            });
    };

    const showCreateModal = () => {
        $(`#${CREATE_CLIENT_MODAL_ID}`).modal('show');
    };

    const closeModal = () => {
        $(`#${CREATE_CLIENT_MODAL_ID}`).modal('hide');
    };

    const addNewApp = () => {
        showCreateModal();
    };

    return (
        <div className="table__card">
            <div className="tw-flex tw-items-start tw-justify-between tw-mb-6">
                <h5 className="table__header">{$t('Apps')}</h5>
                <div className="tw-flex tw-gap-x-1.5">
                    {props.canCreate && (
                        <>
                            <button className="inbud-button" onClick={addNewApp}>
                                <PlusCircleIcon className="tw-w-3 tw-h-3" />
                                {$t('New App')}
                            </button>
                        </>
                    )}
                </div>
            </div>

            <ApiClientsList apps={apps} />

            <ApiClientsCreateModal
                onClose={closeModal}
                onSubmit={storeNewApp}
                categories={props.categories}
                types={props.types}
                defaultCategory={props.defaultCategory}
                defaultType={props.defaultType}
            />
        </div>
    );
}

if (document.getElementById('ApiClientsList')) {
    const rootEl = document.getElementById('ApiClientsList');
    ReactDOM.render(
        <App>
            <ApiClientsIndex
                fetchUrl={fetchUrl}
                storeUrl={storeUrl}
                canCreate={true}
                categories={categories}
                types={types}
                defaultCategory={defaultCategory}
                defaultType={defaultType}
            />
        </App>,
        rootEl,
    );
}
